import { render, staticRenderFns } from "./FormSelectorField.vue?vue&type=template&id=4d02c0bc&"
import script from "./FormSelectorField.vue?vue&type=script&lang=js&"
export * from "./FormSelectorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports